import React, { Fragment } from "react";
import QuotableTest from "./QuotableTest";
import QuotableGroup from "./QuotableGroup";

export default function Quotables({
  quotables,
  renderCheckbox,
  renderPrice,
  isDisabled,
  isVisible = () => true
}) {
  return (
    <Fragment>
      {quotables
        .filter(isVisible)
        .map((q, index) =>
          q.type == "group" ? (
            <QuotableGroup
              key={index}
              quotable={q}
              isDisabled={isDisabled}
              isVisible={q.level !== 0 || q.can_add_to_sample ? () => true : isVisible}
              renderCheckbox={renderCheckbox}
              renderPrice={renderPrice}
            />
          ) : (
            <QuotableTest
              key={index}
              quotable={q}
              disabled={isDisabled(q)}
              renderCheckbox={renderCheckbox}
              renderPrice={renderPrice}
            />
          )
        )}
    </Fragment>
  );
}
